module.exports = __webpack_public_path__ + "static/media/logo.fa828379.png";